'use strict';

require('stb-shim-classlist');
